import { render, staticRenderFns } from "./SliceScriptToggle.vue?vue&type=template&id=f4bd4780&lang=pug&"
import script from "./SliceScriptToggle.vue?vue&type=script&lang=js&"
export * from "./SliceScriptToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports